// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"3cebefa0","498":"3eec44d7","598":"930706f1","787":"678135e4"}[chunkId] + ".chunk.js";
};